import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { forEach, uniqBy } from 'lodash';
import { SearchService } from '.././services/search.service';

@Component({
  selector: 'submarket-search',
  templateUrl: './submarket-search.component.html',
  styleUrls: ['./submarket-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SubmarketSearchComponent implements OnInit, OnDestroy {
  @Input() propSearchInput = new Subject<string>();
  @Output() onSubmarketSelected: EventEmitter<any> = new EventEmitter<any>();

  submarketList: Observable<Array<any>>;

  @Output() showSuggestions: EventEmitter<boolean> = new EventEmitter<boolean>();
  private subscriptions: any[] = [];

  constructor(private searchService: SearchService) { }

  ngOnInit() {
    this.submarketList = this.propSearchInput.debounceTime(400)
      .flatMap(s => this.searchService.getMarketsSubMarkets('mpfsubmarketname:' + s, null))
      .map(submarkets => uniqBy(submarkets.rows, 'MPFSubMarketName'))
      .do(() => this.showSuggestions.emit(true));
  }

  ngOnDestroy() {
    forEach(this.subscriptions, (s) => s.unsubscribe());
    this.subscriptions = [];
    this.onSubmarketSelected.complete();
  }

  submarketSelected(submarket: any) {
    if (!!submarket) {
      let selection: any = { type: "submarket", name: submarket.MPFSubMarketName, latitude: submarket.Latitude, longitude: submarket.Longitude };
      this.onSubmarketSelected.emit(selection);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search/submarket-search/submarket-search.component.ts